'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _handlers = require('./handlers');

var _utils = require('spritespin/release/src/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleCheckClose = function handleCheckClose(event) {
  if (event.keyCode === 27) {
    handleCloseInlineCartClick();
  }
};

var handleCloseInlineCartClick = function handleCloseInlineCartClick() {
  PubSub.publish(_Constants2.default.closeInlineCart, {});
};

var handleToggleInlineCartClick = function handleToggleInlineCartClick(event) {
  event.stopPropagation();
  PubSub.publish(_Constants2.default.toggleInlineCart, {});
  var cartItemsData = CartJS.cart.items.map(function (line_item) {
    return {
      item_id: line_item.id,
      shopify_product_id: line_item.id,
      shopify_variant_id: line_item.id,
      shopify_sku: line_item.sku,
      shopify_handle: line_item.handle,
      shopify_compare_price: Number(line_item.compare_at_price / 100),
      item_name: line_item.title,
      affiliation: window.theme.strings.affiliation,
      currency: window.theme.strings.general.currency_code,
      item_brand: line_item.vendor,
      item_category: line_item.type,
      item_list_id: window.bvaccel.template.name,
      item_list_name: 'cart',
      item_variant: line_item.title,
      item_featured_image: line_item.featured_image,
      option_one: line_item.option1,
      option_two: line_item.option2,
      option_three: line_item.option3,
      price: Number((line_item.price / 100).toFixed(2)),
      quantity: line_item.quantity //double check this
    };
  });
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    'event': 'acn_view_cart',
    'event_id': new Date().getTime() + '.' + Math.random().toString(36).substring(5),
    ecommerce: {
      currency: window.theme.strings.general.currency_code,
      value: Number(CartJS.cart.items_subtotal_price / 100),
      items: cartItemsData
    }
  });
};

var handleOpenInlineCart = function handleOpenInlineCart(event) {
  PubSub.publish(_Constants2.default.openInlineCart, {});
};

var handleShippingOptionToggle = function handleShippingOptionToggle(event) {
  PubSub.publish(_Constants2.default.toggleDiscreteShipping, event);
};

/**
 * If the inline cart is open, check if the user clicked outside the cart
 * and so if it should be closed.
 *
 * @param {EventObject} event: the click event
 */
var checkCloseCart = function checkCloseCart(event) {
  if (event.offsetX < 0) {
    PubSub.publish(_Constants2.default.closeInlineCart, {});
  }
};

var yotpoApply = function yotpoApply(code, action) {
  var checkoutContainer = document.createElement('div');
  checkoutContainer.id = "checkout-container";
  checkoutContainer.style.display = "none";
  var checkoutCart = document.getElementById('checkout-cart-block');
  checkoutCart.appendChild(checkoutContainer);
  var discountApplyUrl = window.location.href + "/checkout?discount=" + code + "&t=" + Date.now();
  fetch(discountApplyUrl).then(function (response) {
    return response.text();
  }).then(function (data) {
    checkoutContainer.innerHTML = data;
    var total = checkoutContainer.querySelector(".payment-due__price").textContent.trim();
    var discontsPrice = document.querySelector(".inline-cart__total-discounted");
    var oldPrice = document.querySelector(".cart__total-amount");
    discontsPrice.innerHTML = total;
    oldPrice.classList.add("quickshop__price-compare", "price__discount-value");
  });
};

/**
 * Bind all actions/listeners that should trigger the inline cart
 */
var bindActions = exports.bindActions = function bindActions() {
  (0, _utils.$)(_Dom2.default.toggleInlineCart).on('click', handleToggleInlineCartClick);
  (0, _utils.$)(document).on('click', _Dom2.default.openInlineCart, handleOpenInlineCart);
  (0, _utils.$)(document).on('click', _Dom2.default.closeInlineCart, handleCloseInlineCartClick);
  (0, _utils.$)(document).on('change', _Dom2.default.discreteShippingToggle, handleShippingOptionToggle);
  (0, _utils.$)(document).on('keydown', handleCheckClose);
  (0, _utils.$)(document).on('click', _Dom2.default.inlineCart, checkCloseCart);
  (0, _utils.$)(document).ready(_handlers.checkIfCartWasAbandoned);

  (0, _utils.$)(document).on('click', '[data-yotpo-header]', function () {
    var $content = (0, _utils.$)('[data-yotpo-body]');

    if ((0, _utils.$)(this).hasClass('is-open')) {
      (0, _utils.$)(this).removeClass('is-open');
      $content.slideUp();
    } else {
      (0, _utils.$)(this).addClass('is-open');
      $content.slideDown();
    }
  });

  (0, _utils.$)(document).on('click', '[data-yotpo-coupon]', function () {
    var heading = (0, _utils.$)(this).text();
    var cost = (0, _utils.$)(this).data('cost');
    var id = (0, _utils.$)(this).data('yotpo-id');
    var $header = (0, _utils.$)('[data-yotpo-header]');
    var $content = (0, _utils.$)('[data-yotpo-body]');
    var $total = (0, _utils.$)('[data-yotpo-total]');

    (0, _utils.$)('[data-yotpo-heading]').text(heading);
    (0, _utils.$)('[data-yotpo-loyalty-cart-wrapper]').attr('data-cost', cost);
    window.localStorage.setItem('yotpo-loyalty-heading', heading);
    window.localStorage.setItem('yotpo-final-cost', cost);
    $header.removeClass('is-open');
    $content.slideUp();
    $total.hide();

    if (window.swellAPI) {
      window.swellAPI.makeRedemption({ redemptionOptionId: id, delayPointDeduction: true }, function (response) {
        window.localStorage.setItem('yotpo-loyalty-reward', response.couponCode);
        yotpoApply(response.couponCode);
      }, function (err) {
        console.log(err);
      });
    }

    if ((0, _utils.$)('.inline-cart__pitcoins').length) {
      var $pitcoins = (0, _utils.$)('.inline-cart__pitcoins .pitcoin');
      var inlineCartHeight = (0, _utils.$)('.inline-cart__content-wrapper').height();
      var loyaltyOffsetHeight = (0, _utils.$)('.inline-cart__yotpo-loyalty').offset().top;
      var secondsItTakesToFall = (0, _utils.$)('.inline-cart__pitcoins').data('seconds');
      var coins = [];

      for (var i = 0; i < $pitcoins.length; i++) {
        coins.push(i);
      }

      var animatePitcoin = function animatePitcoin(i) {
        $pitcoins.eq(i).css({ 'top': inlineCartHeight + 200 + 'px', 'opacity': 1, 'z-index': 1 });
        window.setTimeout(function () {
          $pitcoins.eq(i).css({ 'top': loyaltyOffsetHeight + 2 + 'px', 'opacity': 0, 'z-index': 0, 'transition': 'none' });
        }, secondsItTakesToFall * 1000);
      };

      coins.forEach(function (coin, i) {
        $pitcoins.css({ 'transition': 'top ' + secondsItTakesToFall + 's ease-in' });
        window.setTimeout(function () {
          animatePitcoin(i);
        }, i * 250); // Adjust distance between pitcoins here e.g. 250, 500, etc.
      });
    }
  });
};